import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../../../features/auth';
import { MainSidebar, useSidebar } from '../../../widgets/main-sidebar';
import { Topbar } from '../../../widgets/topbar';
import { StatsSection } from './sections/StatsSection';
import { UsersSection } from './sections/UsersSection';
import { GroupsSection } from './sections/GroupsSection';
import { BoardSection } from './sections/BoardSection';
import { RulesSection } from './sections/RulesSection';
import { LeaderBoardParticipantsSection } from './sections/LeaderBoardParticipantsSection';
import { PartnersSection } from './sections/PartnersSection';
import { ProvidersSection } from './sections/ProvidersSection';
import { SmsTemplatesSection } from './sections/SmsTemplatesSection';
import { ThemesSection } from './sections/ThemesSection';
type AdminSection = 'stats' | 'users' | 'groups' | 'rules' | 'board' | 'lb-participants' | 'partners' | 'providers' | 'sms-templates' | 'themes';
const ADMIN_SECTIONS: AdminSection[] = ['stats', 'users', 'groups', 'board', 'rules', 'lb-participants', 'partners', 'providers', 'sms-templates', 'themes'];

const AdminPage: React.FC = () => {
  const { currentUser, logout } = useAuth();
  const { section: sectionParam } = useParams<{ section: string }>();
  const { toggle } = useSidebar();

  const section: AdminSection = ADMIN_SECTIONS.includes(sectionParam as AdminSection)
    ? (sectionParam as AdminSection)
    : 'stats';

  if (!currentUser) return null;

  const isAdmin = currentUser.role === 'ADMIN';
  // Менеджеру доступна только вкладка «Группы» (просмотр своих групп); остальное — редирект
  if (!isAdmin && section !== 'groups') return <Navigate to="/kanban" replace />;

  return (
    <div id="app-screen">
      <Topbar user={currentUser} onLogout={logout} onSidebarToggle={toggle} />
      <div className="app-body">
        <MainSidebar isAdmin={isAdmin} isManager={currentUser.role === 'MANAGER'} />
        <main className="app-content adm-content">
          {section === 'stats'  && <StatsSection />}
          {section === 'users'  && <UsersSection />}
          {section === 'groups' && <GroupsSection readOnly={!isAdmin} scopeUserId={isAdmin ? undefined : currentUser.id} />}
          {section === 'board'          && <BoardSection />}
          {section === 'rules'          && <RulesSection />}
          {section === 'lb-participants' && <LeaderBoardParticipantsSection />}
          {section === 'partners'        && <PartnersSection />}
          {section === 'providers'        && <ProvidersSection />}
          {section === 'sms-templates'   && <SmsTemplatesSection />}
          {section === 'themes'           && <ThemesSection />}
        </main>
      </div>
    </div>
  );
};

export { AdminPage };
